import { contactCard } from '../../shared';

export const sellersAttorneyContactCard = contactCard(
  'additionalContacts.counterpartyAttorney',
  'counterpartyAttorney',
);
